import { NeutralToneMapping, PCFSoftShadowMap, SRGBColorSpace, WebGLRenderer } from "three";

/**
 * In most use cases this will be called once for each canvas on screen.
 */
export const makeStandardRenderer = (canvas?: HTMLCanvasElement | OffscreenCanvas): WebGLRenderer => {
    const renderer = new WebGLRenderer({
            "antialias": true,
            "alpha": true,
            canvas
        });

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = PCFSoftShadowMap;
    renderer.autoClear = false;
    renderer.outputColorSpace = SRGBColorSpace;
    renderer.toneMapping = NeutralToneMapping;

    return renderer;
}
export default makeStandardRenderer;
